module.exports = __webpack_public_path__ + "static/NeueMontreal-Bold-f618b12105e158ff910f8fc9cdf30a17.woff";